import { useMutation, useQuery } from 'react-query';
import useAuth from './useAuth';

export default function useClinicDocument({ documentId, formId, docId }: any) {
  const { request } = useAuth();

  const {
    data: document,
    refetch: refetchDocument,
    isLoading: isLoadingDocument,
    isRefetching
  } = useQuery(`/clinic-documents/${documentId}`, () => request.get(`/clinic-documents/${documentId}`).then(({ data }) => data), {
    enabled: !!documentId
  });

  // Custom Forms
  const {
    data: customForms,
    refetch: refetchCustomForms,
    isLoading: isLoadingCustomForms
  } = useQuery(
    `/clinic-documents/${documentId}/forms`,
    () => request.get(`/clinic-documents/${documentId}/forms`).then(({ data }) => data),
    {
      enabled: !!documentId
    }
  );

  const { mutateAsync: createClinicDocumentForm, isLoading: isCreatingClinicDocumentForm } = useMutation(
    `/clinic-documents/${documentId}/forms`,
    (payload: any) => request.post(`/clinic-documents/${documentId}/forms`, payload).then(({ data }) => data as any),
    {
      onSuccess: () => {
        refetchCustomForms();
      }
    }
  );

  const { mutateAsync: deleteDocument, isLoading: isDeletingDocument } = useMutation(
    `/clinic-documents/${documentId}`,
    () => request.delete(`/clinic-documents/${documentId}`).then(({ data }) => data as any),
    {
      onSuccess: () => {
        refetchDocument();
      }
    }
  );

  const {
    data: Documents,
    refetch: refetchDocuments,
    isLoading: isLoadingDocuments
  } = useQuery(
    `/clinic-documents/${documentId}/document`,
    () => request.get(`/clinic-documents/${documentId}/document`).then(({ data }) => data),
    {
      enabled: !!documentId
    }
  );

  const { mutateAsync: deleteDoc, isLoading: isDeletingDoc } = useMutation(
    `/clinic-documents/${documentId}/document/${docId}`,
    () => request.delete(`/clinic-documents/${documentId}/document/${docId}`).then(({ data }) => data as any),
    {
      onSuccess: () => {
        refetchDocuments();
      }
    }
  );
  const { mutateAsync: updateDocument, isLoading: isUpdatingDocument } = useMutation(
    `/clinic-documents/${documentId}`,
    (payload: any) => request.put(`/clinic-documents/${documentId}`, payload).then(({ data }) => data as any),
    {
      onSuccess: () => {
        refetchDocument();
        refetchDocuments();
      }
    }
  );

  return {
    Documents,
    deleteDoc,
    isDeletingDoc,
    document,
    updateDocument,
    isUpdatingDocument,
    isLoadingDocument,
    deleteDocument,
    isDeletingDocument,
    isLoadingDocuments,

    // Custom Forms
    customForms,
    refetchCustomForms,
    isLoadingCustomForms,
    createClinicDocumentForm,
    isCreatingClinicDocumentForm
  };
}
